import React, { useCallback, useEffect, useState } from "react"

import { MainFooter } from "../MainFooter"
import { ADD_TEXT, DEFAULT_TAB, TABS, TAB_OVERLAYS, tabType } from "../constants"
import { TextSubFooter } from "../TextSubFooter";
import { ImageSubFooter } from "../ImageSubFooter";
import { useSelector } from "react-redux";
import { useEditModeCapture } from "../../LeftWorkArea/LeftWorkAreaContainer/useEditModeCapture";
import { useAddToCart } from "../../RightPanel/useAddToCart";
import { AddText } from "../TextSubFooter/TextForm";
import { SizeSubFooter } from "../SizeSubFooter";
import { ColorSubFooter } from "../ColorSubFooter";

const Footer = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [cartEnabled, setCartEnable] = useState(false);

    const mode = useEditModeCapture()
    const addToCart = useAddToCart(setCartEnable)

    useEffect(()=>{
        if(mode === 'EDIT_TEXT'){
            setSelectedTab(TABS.TEXT.index)
        }else if (mode === 'EDIT_IMG') {
            setSelectedTab(TABS.IMAGE.index)
        }else{
            setSelectedTab(0)
        }
    },[mode])

    const callback = useCallback((event:TouchEvent)=>{
        const bodyFooter = document.querySelector('.bodyFooter');
        const target = event.target

        if(bodyFooter && target instanceof Node){
            const isClickedOutside = !bodyFooter.contains(target)
            isClickedOutside && setSelectedTab(0)
        }
    },[])

    useEffect(()=>{
        window.addEventListener('touchend',callback)

        return ()=>{
            window.removeEventListener('touchend',callback)
        }
    },[])

    const onTabSelected = useCallback((tab:tabType)=>{
            setSelectedTab(tab.index)
    },[])
   
    switch(selectedTab){
        case TABS.SIZE.index:
            return <SizeSubFooter tabSelection={onTabSelected} />
        case TABS.COLOR.index:
            return <ColorSubFooter tabSelection={onTabSelected}/>    
        case TABS.IMAGE.index:
            return <ImageSubFooter tabSelection={()=>{}}/>
        case TABS.TEXT.index:
            return <TextSubFooter tabSelection={()=>{}}/>
        case TAB_OVERLAYS.ADD_TEXT.index:
            return <AddText />
        case DEFAULT_TAB.index:
        default:
            return <MainFooter cartEnabled={cartEnabled} addToCart={addToCart} tabSelection={onTabSelected}/>
    }
    
}

export default Footer
